import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { fetchNotice } from "api/notice/rests";
import { INoticeView } from "api/notice/types";

import Layout from "layouts";

import { Banner } from "components/commons";
import { axiosFile } from "utils/axiosFile";

const NoticeDetailPage = () => {
  const { noticeId } = useParams();
  const [notice, setNotice] = useState<INoticeView | null>(null);

  useEffect(() => {
    if (noticeId === undefined) return;

    (async () => {
      const { data } = await fetchNotice(Number(noticeId));
      setNotice(data);
    })();
  }, [noticeId]);

  return (
    <Layout>
      <section className="notice-list">
        <div className="inner wrap">
          <article className="board-view-head">
            <div className="view-tit-box">
              <div className="tit-box">{notice?.title}</div>
            </div>

            <div className="view-sub-box">
              <div className="sub-box">운영자</div>
              <div className="sub-box">
                {dayjs(
                  notice?.upd_date ? notice?.upd_date : notice?.reg_date
                ).format(`YYYY.MM.DD HH:mm:ss`)}
              </div>
            </div>
          </article>

          <article className="board-view-body">
            <div className="contents-box">
              {notice?.contents && (
                <div>
                  {notice?.reg_date === "2022-11-01 12:33:23" ? (
                    <Link to="/signup">
                      <div
                        className="data-txt-box"
                        dangerouslySetInnerHTML={{
                          __html: notice?.contents.replaceAll("\n", "<br/>"),
                        }}
                      ></div>
                    </Link>
                  ) : (
                    <div
                      className="data-txt-box"
                      dangerouslySetInnerHTML={{
                        __html: notice?.contents.replaceAll("\n", "<br/>"),
                      }}
                    ></div>
                  )}
                </div>
              )}

              {/* {notice?.contents.split("\n").map((row) => (
                <>
                  {row}
                  <br />
                </>
              ))} */}
            </div>
            {notice?.file_download_link && (
              <button
                className="material-link"
                onClick={() =>
                  axiosFile(
                    notice.file_download_link as string,
                    notice.file_download_filename as string
                  )
                }
              >
                파일 자료 🗂
              </button>
            )}
            <div className="img-box">
              <Banner type="NOTICE_DETAIL" />
            </div>
          </article>
        </div>
      </section>
    </Layout>
  );
};
export default NoticeDetailPage;
